export default __webpack_public_path__ + "static/media/FullSceneMorningBaked.86a81018.glb";